import { useEffect, useRef } from "react";
import useWebSocket from "react-use-websocket";
import numeral from "numeral";
import { useAlert } from "react-alert";

let websocketInstance = null;

// --- Helper ---
const getConnectionId = () => {
  const cid = localStorage.getItem("connectionId");
  return cid && cid !== "null" ? cid : null;
};

export const useTradeWebSocket = (token, user, onTradeEvent) => {
  const alert = useAlert();
  const connectionId = getConnectionId();
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

  // Build WS URL
  const url =
    user?._id && token
      ? `${BASE_URL}/ws/communication?token=${token}${
          connectionId ? `&connectionId=${connectionId}` : ""
        }`
      : null;

  // react-use-websocket hook
  const { getWebSocket, readyState } = useWebSocket(url, {
    shouldReconnect: () => true,
    retryOnError: true,
  });

  const wsRef = useRef(null);

  useEffect(() => {
    if (!url || !token) return;

    // Get the underlying WebSocket instance
    const ws = getWebSocket();

    if (!ws) {
      console.warn("WebSocket instance not ready yet");
      return;
    }

    wsRef.current = websocketInstance || ws;
    websocketInstance = wsRef.current;

    // --- Safe event listener ---
    const handleMessage = (message) => {
      if (!message?.data) return;

      try {
        const eventData = JSON.parse(message.data);

        // -------------------------
        // 🔹 Store connectionId
        // -------------------------
        if (eventData.event === "connectionId") {
          localStorage.setItem("connectionId", eventData.data);
          console.log("ConnectionId received:", eventData.data);
          return;
        }

        // ------------------------------
        // 🔹 Profit Limit or Trade Bust
        // ------------------------------
        if (
          eventData.event === "profit-limit-hit" ||
          eventData.event === "liquidationTriggered"
        ) {
          onTradeEvent(eventData.data, eventData.event);

          try {
            const audio = new Audio("/audios/close-trade-sound.mp3");
            audio.play();
          } catch (e) {
            console.warn("Audio error:", e);
          }

          const subtitle = `Your trade ${
            eventData.event === "liquidationTriggered"
              ? "was busted"
              : "hit the profit limit"
          }
                 with ${eventData.data.profit < 0 ? "a loss of" : "a profit of"}
                  ${numeral(Math.abs(eventData.data.profit)).format("$0,0.00")}
                `;

          alert.show(subtitle);
        }
      } catch (err) {
        console.error("WebSocket parse error:", err);
      }
    };

    // -----------------------------
    // SAFE LISTENER ATTACHING
    // (Fix for Cannot read properties of null)
    // -----------------------------
    ws.addEventListener("message", handleMessage);

    return () => {
      ws.removeEventListener("message", handleMessage);
    };
  }, [token, user, url]);

  return readyState;
};
